export { default } from "./RecordGroupsPanel";
